import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";

import { useDispatch ,useSelector} from "react-redux";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { Updatealbum } from "../../apis/api/GalleryApis";
import { albumGet } from "../../apis/api/GalleryApis";
import Lodderr from "../../components/Lodder/Lodder";
const EditAlbumModal = ({ showModal, closeModal, albumData }) => {
  const dispatch = useDispatch();
  const [albumTitle, setAlbumTitle] = useState("");
  const [mediaFiles, setMediaFiles] = useState([]);
  const [removedFiles, setRemovedFiles] = useState([]);
  const {loading} = useSelector((state)=>state.GallerySlice)

  useEffect(() => {
    setAlbumTitle(albumData?.title || "");

    const existingFiles =
      albumData?.data?.map((item) => ({
        preview: item.file_url,
        extension_type: item.extension_type,
        isNew: false,
        id: item.id,
      })) || [];

    setMediaFiles(existingFiles);
    setRemovedFiles([]);
  }, [albumData]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const newFiles = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      extension_type: file.type.startsWith("video") ? "video" : "image",
      isNew: true,
      id: URL.createObjectURL(file),
    }));
    setMediaFiles((prev) => [...prev, ...newFiles]);
  };

  const removeFile = (index) => {
    const fileToRemove = mediaFiles[index];
    if (!fileToRemove.isNew) {
      setRemovedFiles((prev) => [...prev, fileToRemove.id]);
    }
    setMediaFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    const formData = new FormData();
    const user_id = Cookies.get("userID");
    const company_id = Cookies.get("company_id");
  
    formData.append("title", albumTitle);
    formData.append("album_id", albumData.album_id);
    formData.append("user_id", user_id);
    formData.append("company_id", company_id);
  
    mediaFiles.forEach((media) => {
      if (!removedFiles.includes(media.id) && !media.isNew) {
        formData.append("file_url[]", media.preview);
      }
    });
  
    mediaFiles.forEach((media) => {
      if (media.isNew && media.file) {
        formData.append("Files", media.file);
      }
    });
  
    const response = await dispatch(Updatealbum(formData))
   
    if(response.payload.status === "success"){
      toast.success("Album updated succesfully !");
        await dispatch(albumGet({company_id:company_id}))
        closeModal();
      
    }else{
      toast.error("error while updating .... !");
    }
  

  
  };
  
  return (
    <>
    {loading && <Lodderr/>}
    <Modal show={showModal} size="lg" centered onHide={closeModal}>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>Edit Album</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="container py-2">
          <div className="text-start mb-4">
            <button
              className="btn btn-outline-primary btn-sm"
              type="button"
              onClick={() => document.getElementById("fileInput").click()}
            >
              <i className="bx bxs-inbox"></i> Upload Media
            </button>
            <input
              id="fileInput"
              type="file"
              multiple
              className="d-none"
              onChange={handleFileChange}
              accept="image/*,video/*"
            />
          </div>

          <div className="mb-4">
            <label htmlFor="albumTitle" className="form-label fw-semibold">
              Album Title
            </label>
            <input
              type="text"
              className="form-control"
              id="albumTitle"
              value={albumTitle}
              onChange={(e) => setAlbumTitle(e.target.value)}
              placeholder="Enter album title"
            />
          </div>

          {/* Media Preview Grid */}
          <div className="mb-2">
            <label className="form-label fw-semibold">Media Files</label>
            <div className="row g-3">
              {mediaFiles.map((media, index) => (
                <div key={media.id || index} className="col-sm-6 col-md-4 col-lg-3">
                  <div className="position-relative border rounded shadow-sm p-2">
                    <button
                      type="button"
                      className="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                      onClick={() => removeFile(index)}
                      style={{ zIndex: 1 }}
                    >
                      <i className="bx bxs-message-square-x"></i>
                    </button>

                    {media.extension_type === "video" ? (
                      <video
                        controls
                        src={media.preview}
                        className="w-100 rounded"
                        style={{ height: "150px", objectFit: "cover" }}
                      />
                    ) : (
                      <img
                        src={media.preview}
                        alt={`Media ${index + 1}`}
                        className="w-100 rounded"
                        style={{ height: "150px", objectFit: "cover" }}
                      />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="bg-light">

        <button className="btn btn-primary" onClick={handleSave}>
          <i className="fas fa-save me-1"></i> Save Changes
        </button>
      </Modal.Footer>
    </Modal>
    </>
  );
};

export default EditAlbumModal;
